import { Pagination } from '@nextui-org/react';
import styled from 'styled-components';

export const PaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 4.3rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    justify-content: center;
    margin-top: 1rem;
  }
`;

export const StyledPagination = styled(Pagination)`
  .nextui-pagination-item {
    background-color: ${({ theme }) => theme.colors.neutrals.white};
    color: ${({ theme }) => theme.colors.neutrals.black};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    border-radius: ${({ theme }) => theme.borderRadius};
  }

  .nextui-pagination-highlight {
    background-color: ${({ theme }) => theme.colors.neutrals.white};
    border-radius: ${({ theme }) => theme.borderRadius};
  }

  .nextui-pagination-highlight--active {
    border: 1px solid ${({ theme }) => theme.colors.primary.c400};
    background-color: ${({ theme }) => theme.colors.neutrals.white};
  }
  .nextui-pagination-item-active {
    box-shadow: none;
    .nextui-pagination-item-content {
      font-weight: ${({ theme }) => theme.fontWeight.medium};
      color: ${({ theme }) => theme.colors.primary.c400};
    }
  }

  .nextui-pagination-item-disabled {
    .nextui-pagination-item-content {
      opacity: 0.2;
    }
  }
`;
